import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

interface RegeneratePairingCodeResult {
  pairingCode: string
  expiresAt: Date
}

async function regeneratePairingCode(deviceId: string): Promise<RegeneratePairingCodeResult> {
  const { data, error } = await supabase
    .rpc('regenerate_pairing_code', { p_device_id: deviceId })
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  return {
    pairingCode: data.pairing_code as string,
    expiresAt: new Date(data.expires_at as string),
  }
}

export function useRegeneratePairingCode() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: regeneratePairingCode,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['devices'] }),
  })
}
